import toast from './toast.json';
import translation from './translation.json';
import validForm from './validForm.json';

export const trTranslations = {
	translation,
	validForm,
	toast,
};
